import { UnitType } from '@exodus/currency'

const name = 'zcash'
const displayName = 'Zcash'
const ticker = 'ZEC'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#FFC633'
const gradientColors = ['#FFC633', '#DD8A00']
const gradientCoords = { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  ZEC: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.zcha.in/accounts/${address}/`,
  txUrl: (txId) => `https://explorer.zcha.in/transactions/${txId}/`,
}
const info = {
  description:
    'Zcash is an open-source, permission-less cryptocurrency that protects the privacy of transactions using zero-knowledge cryptography (zk-SNARKS).',
  reddit: 'https://www.reddit.com/r/zec/',
  twitter: 'https://twitter.com/electriccoinco',
  website: 'https://z.cash/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
